const types = {
	//Get Template name
	GET_CLIENT_DETAILS_START: "GET_CLIENT_DETAILS_START",
	GET_CLIENT_DETAILS_SUCCESS: "GET_CLIENT_DETAILS_SUCCESS",
	GET_CLIENT_DETAILS_ERROR: "GET_CLIENT_DETAILS_ERROR",
	GET_CLIENT_DETAILS_RESET: "GET_CLIENT_DETAILS_RESET",

	//Create Template name
	CREATE_CLIENT_DETAILS_START: "CREATE_CLIENT_DETAILS_START",
	CREATE_CLIENT_DETAILS_SUCCESS: "CREATE_CLIENT_DETAILS_SUCCESS",
	CREATE_CLIENT_DETAILS_ERROR: "CREATE_CLIENT_DETAILS_ERROR",
	CREATE_CLIENT_DETAILS_RESET: "CREATE_CLIENT_DETAILS_RESET",

	//delete Template name
	DELETE_CLIENT_DETAILS_START: "DELETE_CLIENT_DETAILS_START",
	DELETE_CLIENT_DETAILS_SUCCESS: "DELETE_CLIENT_DETAILS_SUCCESS",
	DELETE_CLIENT_DETAILS_ERROR: "DELETE_CLIENT_DETAILS_ERROR",
	DELETE_CLIENT_DETAILS_RESET: "DELETE_CLIENT_DETAILS_RESET",

	//update Template name
	UPDATE_CLIENT_DETAILS_START: "UPDATE_CLIENT_DETAILS_START",
	UPDATE_CLIENT_DETAILS_SUCCESS: "UPDATE_CLIENT_DETAILS_SUCCESS",
	UPDATE_CLIENT_DETAILS_ERROR: "UPDATE_CLIENT_DETAILS_ERROR",
	UPDATE_CLIENT_DETAILS_RESET: "UPDATE_CLIENT_DETAILS_RESET",

	//single item  name
	SINGLE_CLIENT_DETAILS_START: "SINGLE_CLIENT_DETAILS_START",
	SINGLE_CLIENT_DETAILS_SUCCESS: "SINGLE_CLIENT_DETAILS_SUCCESS",
	SINGLE_CLIENT_DETAILS_ERROR: "SINGLE_CLIENT_DETAILS_ERROR",
	SINGLE_CLIENT_DETAILS_RESET: "SINGLE_CLIENT_DETAILS_RESET",
};

export default types;
